module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/inspiration-elite-toolbar-50.39c75471.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/inspiration-elite-toolbar-50.png
// module id = 3719
// module chunks = 11